import { render, staticRenderFns } from "./AtestoForm.vue?vue&type=template&id=8610c3c6&"
import script from "./AtestoForm.vue?vue&type=script&lang=js&"
export * from "./AtestoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports